var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isRedirecting),expression:"isRedirecting"}],staticClass:"paper-analysis-redirect"},[_c('div',{staticClass:"redirect-tip"},[_vm._v("正在打开论文分析...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }